import { render } from "./CreateTwoot.vue?vue&type=template&id=65c2cc19&scoped=true&bindings={\"state\":\"setup\",\"newTwootCharachterCount\":\"setup\",\"isDisabled\":\"setup\",\"createNewTwoot\":\"setup\"}"
import script from "./CreateTwoot.vue?vue&type=script&lang=js"
export * from "./CreateTwoot.vue?vue&type=script&lang=js"

import "./CreateTwoot.vue?vue&type=style&index=0&id=65c2cc19&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65c2cc19"

export default script